
<script>
/*eslint no-mixed-spaces-and-tabs: */
import Vue from "vue";
import { appConstants } from "@/services/constants.js";
import axios from "axios";
import pdfviewer from "./pdf-viewer"
import Swal from "sweetalert2";
import { cryptoMixin } from "@/mixins/cryptoMixin";
import { cookieMixin } from "@/mixins/cookieMixin";
//import { pdfeMixin } from "@/mixins/pdfeMixin"


export default {
	name: 'MainView',
	components: {
		pdfviewer
	},
	mixins:[cryptoMixin, cookieMixin],
	data: function(){
		
		return {
			apiRoot: "",
			file: "",
			pdfFile: "",
			pdfFileName: "",
			pdfPassword: "",
			isLoading: false,
			showNoPrint: false,
			showLoader:false,
			userEmail:"",
			uploadProgress: 0,
			appMode: Vue.prototype.$appmode,
			workingFile:"",
			totalPages:0,
			streamPdf:false,
			shareId:""
		}
	},
	computed: {
		apiEndpoint: function() {
			
			var constants = appConstants.constants();
			
			return `${constants.BASE_URL}/api`;
		}
	},
	mounted(){
		//document.addEventListener("message", this.messageHandler, false);	
	},
	created()
	 { 
	   let urlParams = new URLSearchParams(window.location.search);
		   if(urlParams.has('pdfefile')){
			  
			  this.showLoader = true;
			  
			   var pdfeFile = urlParams.get('pdfefile');
			   var body = {
				   'url': pdfeFile,
				   'apikey': "",
				   'deviceId': this.createUUID(),
				   'userEmail': this.userEmail
			   }
			   var headers = {
				   "x-web-key":this.createUUID()
			   }
			   
			   window.history.pushState({}, document.title, window.location.pathname);
			   
			   axios.post( `${this.apiEndpoint}/pdfeviewer/getrawfromurl`,
				   body, {
					   headers: headers
				   })
			   .then(data => {
				   var result = data.data;
				   var extractionResult = result.extractionResult;
				   
				   this.processExtractionResult(extractionResult, result.base64Data);
			   })
			   
			   //send the file to API and then return with a PDF file
			   this.file = ''; //download the file to base64
			  
		   }
		   else if (urlParams.has('sid')){
			   this.showLoader = true;
				  
				this.shareId = urlParams.get('sid');
				  
				  var pbody = {
					  'Id': this.shareId,
					  'Password':"",
					  'DeviceId': this.getDeviceId()
				  }
				  
				  window.history.pushState({},document.title, window.location.pathname);
				  
				  //first get the total pages from this PDF
				  var vm = this;
				  
				  axios.post(`${this.apiEndpoint}/document/getpagecount`, pbody)
				  .then(data => {
					  var result = data.data;
					  vm.totalPages = result.totalPages;
					  vm.workingFile = result.workingFile
					  
					  var drmResult = result.extractionResult;
					  
					  if (this.totalPages > 10){
						  pbody.workingFile = vm.workingFile
						  pbody.pageNumber = 1
						  
						  vm.streamPdf = true;
					  }
					  
					  axios.post(`${this.apiEndpoint}/document/getpdffromshare`, pbody)
						 .then(data => {
							 var result = data.data;
							 var extractionResult = drmResult;
								
							 this.processExtractionResult(extractionResult, result.base64Data);
					   })
					  
				  })
		   }
		   else if (urlParams.has('pdfedata')){
			   this.showLoader = true;
			   
			   var pdfeBase64 = urlParams.get('pdfedata')
			   
			   this.file = this.dataURLtoFile(pdfeBase64, "pdfe file")
		   }
	 },
	methods: {
		messageHandler(){
			alert('test')
			const { action, key, value } = event.data
			
			if (action == 'save'){
				console.log(value)
				window.localStorage.setItem(key, value)
			}	
		},
		dataURLtoFile(dataurl, filename) {
		
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]), 
				n = bstr.length, 
				u8arr = new Uint8Array(n);
				
			while(n--){
				u8arr[n] = bstr.charCodeAt(n);
			}
			
			return new File([u8arr], filename, {type:mime});
		},
		getDeviceId(){
			var deviceId = this.getCookie("deviceId")
			
			if (deviceId == null || deviceId == ""){
				deviceId = this.createUUID();
				
				this.setCookie("deviceId", deviceId, 3650)
			}
			
			return deviceId;
		},
		createUUID() {
			  var result = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				
				return v.toString(16);
			  });
			  
			  return result;
			},
		closePdf() {
			location.reload();
		},
	  handleFileUpload(){
	  	this.file = this.$refs.file.files[0];
	  },
	  isHTML(str) {
			var doc = new DOMParser().parseFromString(str, "text/html");
			return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
		  },
	  processExtractionResult(extractionResult, data){
		  	var vm = this
			  
			if (extractionResult.Success){
				  vm.pdfFileName = extractionResult.Payload.FileNameV2;
				  
				  vm.pdfFile = `data:application/pdf;base64,${data}`;
			  }
			  else{
				  if (vm.isHTML(extractionResult.Payload.ExpiryMessage)){
					  Swal.fire({
						  icon: 'error',
						  title: 'Document Expired',
						  html: extractionResult.Payload.ExpiryMessage,
						  footer: 'Please contact the document author'
						})
				  }
				  else{
					  Swal.fire({
							icon: 'error',
							title: 'Document Expired',
							text: extractionResult.Payload.ExpiryMessage,
							footer: 'Please contact the document author'
						  })
				  }
			  }
	  },
	  getRaw(formData, config){
		  var vm = this;
		  
		  
		  axios.post( `${this.apiEndpoint}/pdfeviewer/getraw`,
			  formData,config
			).then(function(data){
				var result = data.data;
				var extractionResult = result.extractionResult;
				
				if (extractionResult.Success){
					
					vm.pdfFileName = extractionResult.Payload.FileNameV2;
					
					//var decrypted = vm.decryptString(result.base64Data);
					
					vm.pdfFile = `data:application/pdf;base64,${result.base64Data}`;
				}
				else{
					if (extractionResult.Payload == null){
						Swal.fire({
							icon: 'error',
							title: 'Access Error',
							html: extractionResult.Reason,
							footer: 'Please contact the document author'
						  })
					}
					else if (vm.isHTML(extractionResult.Payload.ExpiryMessage)){
						Swal.fire({
							icon: 'error',
							title: 'Document Expired',
							html: extractionResult.Payload.ExpiryMessage,
							footer: 'Please contact the document author'
						  })
					}
					else{
						Swal.fire({
							  icon: 'error',
							  title: 'Document Expired',
							  text: extractionResult.Payload.ExpiryMessage,
							  footer: 'Please contact the document author'
							})
					}
				}
				vm.isLoading = false;
			})
			.catch(function(error){
				vm.isLoading = false;
			  console.log({error});
			  
			  Swal.fire({
				  icon: 'error',
				  title: 'Error',
				  text: `Could not open the file. Reason (${error}). Make sure it is a valid PDFe file`,
				  footer: 'Please let us know by sending an email to info@allaboutpdf.com'
				})
			});
	  },
	  submitFile(){
		  var vm = this;
		  
		  this.isLoading = true;
		 
		  var guid =  this.getDeviceId();
		  let formData = new FormData();
		  formData.append('file', this.file);
		  formData.append("password", this.pdfPassword);
		  formData.append("deviceid", guid);
		  formData.append("useremail", this.userEmail)
		  
		  var uploadProgress = (event) => {
			 vm.uploadProgress = Math.round((event.loaded / event.total) * 100)
		   }
		   
		  let config = {
			  headers: {
				  'Content-Type': 'multipart/form-data',
				  'x-web-key': guid
			  },
			  onUploadProgress: uploadProgress
		  };
		  
		  vm.getRaw(formData, config);
		  	
	  },
	}
  }
</script>
<style scoped>
	.file-select > .select-button {
	  padding: 1rem;
	  color: #f75759;
	  border-style: solid;
	  border-width: 1px;
	  border-color: rgb(223,233,242);;
	  background-color: white;
	  border-radius: .3rem;
	  text-align: center;
	  font-weight: bold;
	  min-width:300px;
	  box-shadow: rgb(0 0 0 / 10%) 0 2px 4px 0;
	  transition-duration: .3s,.3s;
	  transition-timing-function: cubic-bezier(.455,.03,.515,.955),cubic-bezier(.455,.03,.515,.955);
	  cursor: pointer;
	}
	.file-select > .select-button:hover {
		box-shadow: rgba(0, 0, 0, 0.2) 0px 30px 60px 0px;
		transform: translateY(-3px);
	}
	
	.viewer{
		margin-top:-10px;
	}
	
	@media print {
		.viewer {
			display:none;
		}
		.canva{
			display:inline-block;
		}
	}
	
	@media not print {
		.canva{
			display: none;
		}
	}
	
	/* Don't forget to hide the original file input! */
	.file-select > input[type="file"] {
	  display: none;
	}
	
	.shadow{
		box-shadow: 0 15px 35px 0 rgba(60,66,87,.08),0 5px 15px 0 rgba(0,0,0,.12);
	}
	</style>
<template>
<div class="container">
	<p v-if="appMode != 'production'">{{appMode}}</p>
	<div class="card animate__animated animate__fadeIn shadow" v-if="pdfFile == ''">
		<div class="card-header" style="border-bottom:none">
			<div class="card-title">
				<h4 style="font-weight: bolder;text-transform: uppercase;font-family: 'Quicksand', sans-serif;">All About PDF</h4>
			</div>
			<a href="https://allaboutpdf.com" target="_blank"><img src="/media/logo.png" width="64px"/></a>
			<div class="card-title">
				<h5 style="color:#E53B3B">PDFe Reader</h5>
			</div>
		</div>
		<div class="card-body" v-if="showLoader == false">
			<div class="row">
				<div class="col-md-12">
					<label class="file-select" >
						  <!-- We can't use a normal button element here, as it would become the target of the label. -->
						  <div class="select-button">
							<!-- Display the filename if a file has been selected. -->
							<span v-if="file">Selected File: {{file.name}}</span>
							<span v-else>Select PDFe File</span>
						  </div>
						<input type="file" id="file" ref="file" v-on:change="handleFileUpload()" style="display:none;" accept=".pdfe"/>
					 
						
						</label>
				</div>
				
			</div>
			<!--<div class="row  justify-content-center">
				<div class="col-md-6">
				<div class="form-group">
					<label for="exampleInputEmail1">PDF Password (Optional)</label>
					<input type="password" class="form-control" id="password" aria-describedby="password" placeholder="Enter PDF Password if needed" v-model="pdfPassword">
					<small id="emailHelp" class="form-text text-muted">Use this field if the PDFe file is password protected</small>
				  </div>
				</div>
			</div>-->
			<div class="row" v-if="file != ''">
				<div class="col-md-4" style="margin:auto" >
					<label for="userEmail" style="margin-top:15px">If the document's owner has specified that your email address is required to view it, please enter it below.</label>
					<b-form-input style="margin-bottom:15px;text-align:center" v-model="userEmail" type="email" placeholder="Email Address" id="userEmail"></b-form-input>
				</div>
			</div>
			<div class="row" v-if="file != ''">
				<div class="col-md-12">
					<button :disabled="isLoading" v-on:click="submitFile()" class="btn btn-primary">OPEN FILE <i v-if="isLoading" class="fas fa-spinner fa-spin"></i></button>
				</div>
				<div class="col-md-12" v-if="isLoading">
					<b-progress :max="100" variant="primary" class="push" animated style="margin-top:5px" >
						<b-progress-bar :value="uploadProgress" :label-html="`<span class='font-size-sm font-w600'>${uploadProgress.toFixed()}%</span>`"></b-progress-bar>
					  </b-progress>
				</div>
			</div>
			
		</div>
		<!--this is the loading spinner when a document url is provided-->
		<div style="padding:10px;" v-if="showLoader == true">
			<div class="spinner-border text-danger" role="status" style="margin:auto;padding:10px">
				  <span class="sr-only">Loading...</span>
			</div>
			<span style="padding-left:10px;padding-bottom:10px;vertical-align:super">Please wait for the document to load...</span>
		</div>
		
		<div class="row" style="margin:auto; margin-top:10px">
			<div class="col-md-12">
			<p style="text-align:center;font-size:small" ><a href="https://allaboutpdf.com/drm-protection-for-pdf-files" target="_blank">How to create PDFe Files</a></p>
			</div>
		</div>
	</div>
	<div v-else>
		<div class="alert alert-danger canva" role="alert">
			  Printing is not allowed.
		</div>
		<div class="card animate__animated animate__fadeIn">
			<div class="card-header" style="border-bottom:none;max-height:45px">
				<div class="row">
					<div class="col-md-11">
						<h5 class="card-title">{{pdfFileName}}</h5>
					</div>
					<div class="col-md-1 float-right" v-if="this.showLoader == false" style="text-align:right">
						<i class="fas fa-times-circle" style="cursor: pointer;" @click="closePdf()"></i>
					</div>
				</div>
			</div>
			<div class="card-body viewer" >
				<pdfviewer :fileUrl="pdfFile" :streamPdf="streamPdf" :pageCount="totalPages" :shareId="shareId" :workingFile="workingFile" :apiEndpoint="apiEndpoint" ></pdfviewer>
			</div>
		</div>
	</div>
	
  </div>
</template>
